// src/components/strumenti/SuperficiePerimetro.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"9px 10px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

const FORME = {
  rettangolo: { label:"Rettangolo", campi:["base","altezza"] },
  triangolo: { label:"Triangolo (base × altezza)", campi:["base","altezza","lato2","lato3"] },
  cerchio: { label:"Cerchio", campi:["raggio"] },
  trapezio: { label:"Trapezio", campi:["baseMaggiore","baseMinore","altezza","latoObliquo1","latoObliquo2"] },
};

export default function SuperficiePerimetro() {
  const [forma, setForma] = useState("rettangolo");
  const [valori, setValori] = useState({});

  const v = k => leggiNumero(valori[k])||0;
  const set = (k,val) => setValori(o=>({...o,[k]:val}));

  let superficie=null, perimetro=null;
  if (forma==="rettangolo") {
    const b=v("base"), h=v("altezza");
    if (b>0&&h>0) { superficie=b*h; perimetro=2*(b+h); }
  } else if (forma==="triangolo") {
    const b=v("base"), h=v("altezza");
    if (b>0&&h>0) { superficie=(b*h)/2; }
    // W442: con gli altri due lati (facoltativi) anche il perimetro
    const l2=v("lato2"), l3=v("lato3");
    if (b>0&&l2>0&&l3>0) perimetro=b+l2+l3;
  } else if (forma==="cerchio") {
    const r=v("raggio");
    if (r>0) { superficie=Math.PI*r*r; perimetro=2*Math.PI*r; }
  } else if (forma==="trapezio") {
    const B=v("baseMaggiore"), b=v("baseMinore"), h=v("altezza");
    if (B>0&&h>0) { superficie=((B+b)/2)*h; }
    const o1=v("latoObliquo1"), o2=v("latoObliquo2");
    if (B>0&&b>0&&o1>0&&o2>0) perimetro=B+b+o1+o2;
  }

  const LABEL_CAMPO = { base:"Base (m)", altezza:"Altezza (m)", raggio:"Raggio (m)", baseMaggiore:"Base maggiore (m)", baseMinore:"Base minore (m)",
    lato2:"Secondo lato (m) — per il perimetro", lato3:"Terzo lato (m) — per il perimetro", latoObliquo1:"Lato obliquo 1 (m) — per il perimetro", latoObliquo2:"Lato obliquo 2 (m) — per il perimetro" };

  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Forma</label>
        <select value={forma} onChange={e=>{setForma(e.target.value);setValori({});}} style={inp}>
          {Object.entries(FORME).map(([k,f]) => <option key={k} value={k}>{f.label}</option>)}
        </select>
      </div>

      <div style={{ display:"grid", gridTemplateColumns: FORME[forma].campi.length===4 ? "1fr 1fr" : FORME[forma].campi.length>2 ? "1fr 1fr 1fr" : "1fr 1fr", gap:10, marginBottom:16 }}>
        {FORME[forma].campi.map(c => (
          <div key={c}>
            <label style={lbl}>{LABEL_CAMPO[c]}</label>
            <input value={valori[c]||""} onChange={e=>set(c,e.target.value)} style={inp} placeholder="Es. 5"/>
          </div>
        ))}
      </div>

      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around" }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Superficie</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#15803d" }}>{superficie!==null ? superficie.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"} <span style={{fontSize:12,color:"#9ca3af"}}>m²</span></div>
          </div>
          {perimetro!==null && (
            <div style={{textAlign:"center"}}>
              <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Perimetro</div>
              <div style={{ fontSize:20, fontWeight:800, color:"#15803d" }}>{perimetro.toLocaleString("it-IT",{maximumFractionDigits:2})} <span style={{fontSize:12,color:"#9ca3af"}}>m</span></div>
            </div>
          )}
        </div>
      </div>

      <button onClick={()=>setValori({})}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
